module.exports = __webpack_public_path__ + "assets/img/df67278fe36bad9c3ad08cf2cbfdda62.svg";